<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="dialog.addDialog = true"
          >新增广播</el-button
        >
        <el-tooltip
          class="item"
          effect="light"
          content="广播品牌单间学校仅支持一种，请根据实际情况选择"
          placement="top"
        >
          <span style="margin:0px 10px 0px 20px">
            广播品牌:
          </span>
        </el-tooltip>
        <el-radio-group class="brand-group" v-model="brand" size="mini">
          <el-radio
            v-for="(value, key) in $store.state.select.broadcastBrand"
            :value="value.id"
            :key="key"
            :label="value.id"
            @click.native.prevent="select(value.id, value.name)"
          >
            {{ value.name }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="areaNum" label="区域编号" align="center">
          </el-table-column>
          <el-table-column prop="areaName" label="区域名称" align="center">
          </el-table-column>
          <el-table-column prop="sim" label="SIM卡号" align="center">
          </el-table-column>
          <el-table-column prop="voiceBrand" label="广播品牌" align="center">
            <template v-slot="scope">
              <div>
                {{
                  $store.state.select.broadcastBrand[scope.row.voiceBrand].name
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="广播状态" align="center">
            <template v-slot="scope">
              <el-tag type="info" v-if="scope.row.status == 0">空闲</el-tag>
              <el-tag type="success" v-if="scope.row.status == 1"
                >运行中</el-tag
              >
              <el-tag type="danger" v-if="scope.row.status == 2">离线</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="openEditBox(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box" v-if="brand == 1"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="selArea(scope.row)"
                      :underline="false"
                      >分区</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box">
                    <el-link
                      class="link_box"
                      type="primary"
                      :underline="false"
                      @click="sel(scope.row.id)"
                      >控制器</el-link
                    >
                  </el-dropdown-item>
                  <el-dropdown-item
                    class="dropdown_item_box"
                    v-if="brand == 1 && scope.row.isAccessTp == 1"
                  >
                    <el-link
                      class="link_box"
                      type="primary"
                      :underline="false"
                      @click="selLine(scope.row)"
                      >线路输入服务器</el-link
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
      <!-- 新增广播区域 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog.addDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        title="新增广播区域"

        size="42%"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <el-form label-width="110px">
            <el-form-item label="区域名称">
              <el-input
                size="small"
                v-model.trim="insertData.areaName"
                placeholder="请填写区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域编号">
              <el-input
                size="small"
                v-model.trim="insertData.areaNum"
                placeholder="请填写区域编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="SIM卡号">
              <el-input
                size="small"
                v-model.trim="insertData.sim"
                placeholder="请填写SIM卡号"
              ></el-input>
            </el-form-item>
            <el-form-item label="广播品牌">
              <el-select
                v-model="insertData.voiceBrand"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in $store.state.select.broadcastBrand"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="接入第三方广播">
              <el-radio-group
                class="brand-group"
                v-model="insertData.isAccessTp"
                size="mini"
              >
                <el-radio :label="0">不接入</el-radio>
                <el-radio :label="1">接入</el-radio>
              </el-radio-group>
              <span class="tip">(仅适用于云广播)</span>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="broadcastRegionOperation(1)"
                >确定添加</el-button
              >
              <el-button size="mini" @click="cancelForm">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!-- 编辑广播区域 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog.editDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        title="编辑广播区域"
         width="800px"
        append-to-body
        size="42%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <el-form label-width="110px">
            <el-form-item label="区域名称">
              <el-input
                size="small"
                v-model.trim="editData.areaName"
                placeholder="请填写区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域编号">
              <el-input
                size="small"
                v-model.trim="editData.areaNum"
                placeholder="请填写区域编号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="SIM卡号">
              <el-input
                size="small"
                v-model.trim="editData.sim"
                placeholder="请填写SIM卡号"
              ></el-input>
            </el-form-item>
            <el-form-item label="广播品牌">
              <el-select
                v-model="editData.voiceBrand"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in $store.state.select.broadcastBrand"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="接入第三方广播">
              <el-radio-group
                class="brand-group"
                v-model="editData.isAccessTp"
                size="mini"
              >
                <el-radio :label="0">不接入</el-radio>
                <el-radio :label="1">接入</el-radio>
              </el-radio-group>
              <span class="tip">(仅适用于云广播)</span>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="broadcastRegionOperation(2)"
                >确定添加</el-button
              >
              <el-button size="mini" @click="cancelForm">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
    <area-dialog
      :areaResize="areaResize"
      :areaInfo="areaInfo"
      @getList="getBroadcastBrand"
    ></area-dialog>
    <line-dialog
      :lineResize="lineResize"
      :areaNum="areaNum"
      @getList="getBroadcastBrand"
    ></line-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import CampusBroadcastSettings from "@/components/CampusBroadcastSettings";
import areaDialog from "./components/BroadcastBindingArea.vue";
import lineDialog from "./components/BroadcastBindingLine.vue";
export default {
  name: "",
  components: {
    CampusBroadcastSettings,
    areaDialog,
    lineDialog
  },
  props: {},
  data() {
    return {
      dialog: {
        addDialog: false,
        editDialog: false
      },
      brand: "",
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20
      },
      insertData: {
        areaNum: "",
        areaName: "",
        sim: "",
        voiceBrand: 0,
        isAccessTp: 0,
        schoolId: this.$store.state.schoolId
      },
      editData: {
        id: "",
        areaNum: "",
        areaName: "",
        sim: "",
        voiceBrand: "",
        isAccessTp: 0,
        schoolId: this.$store.state.schoolId
      },
      areaResize: 0,
      areaInfo: {},
      lineResize: 0,
      areaNum: ""
    };
  },
  created() {},
  mounted() {
    this.getBroadcastBrand();
  },
  watch: {},
  computed: {},
  methods: {
    clearData() {
      this.insertData = {
        areaNum: "",
        areaName: "",
        sim: "",
        voiceBrand: "",
        isAccessTp: 0,
        schoolId: this.$store.state.schoolId
      };
      this.editData = {
        id: "",
        areaNum: "",
        areaName: "",
        sim: "",
        voiceBrand: "",
        isAccessTp: 0,
        schoolId: this.$store.state.schoolId
      };
    },
    openEditBox(thisData) {
      this.editData.id = thisData.id;
      this.editData.areaNum = thisData.areaNum;
      this.editData.areaName = thisData.areaName;
      this.editData.sim = thisData.sim;
      this.editData.voiceBrand = thisData.voiceBrand;
      this.editData.isAccessTp = thisData.isAccessTp;
      this.dialog.editDialog = true;
    },
    handleCurrentChange(val) {
      this.requestParams.pageNum = val;
      this.getBroadcastRegion();
      console.log(`当前页: ${val}`);
    },
    select(id, name) {
      // console.log(id, name);
      this.$confirm(
        "您确认要将广播品牌切换为" + name + "吗？切换品牌后会影响广播使用！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.brand = id;
          this.editBroadcastBrand(id);
        })
        .catch(() => {});
    },
    selArea(item) {
      this.areaInfo = item;
      this.areaResize++;
    },
    sel(id) {
      this.$store.commit("updateBroadcastId", id);
      this.$Common.pageJump("/broadcastController", 3);
    },
    selLine(item) {
      this.areaNum = item.areaNum;
      this.lineResize++;
    },
    // 新增 / 编辑 广播区域
    async broadcastRegionOperation(operation = 1) {
      var newRequestData = this.insertData;
      if (operation == 2) {
        var newRequestData = this.editData;
      }
      if (!newRequestData.areaName) {
        this.$message("请输入区域名称！");
        return;
      }
      if (!newRequestData.areaNum) {
        this.$message("请输入区域编号！");
        return;
      }
      // if(!newRequestData.voiceBrand) {
      //   this.$message("请选择广播品牌！");
      //   return;
      // }
      // if(!newRequestData.sim) {
      //   this.$message("请输入SIM卡号！");
      //   return;
      // }
      let loadingInstance = Loading.service();
      let res = await this.$Http.broadcastRegionOperation(newRequestData, true);
      loadingInstance.close();
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.cancelForm();
        this.getBroadcastRegion();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取广播区域
    async getBroadcastRegion() {
      var newParamData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize,
        voiceBrand: this.brand
      };

      let res = await this.$Http.getBroadcastRegion(newParamData);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取校园广播品牌
    async getBroadcastBrand() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getBroadcastBrand(req);
      if (res.code == 200) {
        this.brand = res.data;
        this.getBroadcastRegion();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 编辑校园广播品牌
    async editBroadcastBrand(brand) {
      let req = {
        schoolId: this.$store.state.schoolId,
        brand: brand
      };
      let res = await this.$Http.editBroadcastBrand(req);
      if (res.code == 200) {
        this.getBroadcastRegion();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 删除数据
    delData(dataId) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = {
            id: dataId
          };
          console.log(requestData);
          // return false
          let res = await this.$Http.delBroadcastRegion(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getBroadcastRegion();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    cancelForm() {
      this.dialog.addDialog = false;
      this.dialog.editDialog = false;
      this.clearData();
    }
  }
};
</script>
<style scoped lang="scss">
.brand-group {
  position: relative;
  top: 4px;
}
.tip {
  display: inline-block;
  padding-left: 50px;
  color: #969696;
}
.el-input {
  width: 100%;
}
</style>
